import { render, staticRenderFns } from "./TravelNoteDetail.vue?vue&type=template&id=0e8df05e&scoped=true"
import script from "./TravelNoteDetail.vue?vue&type=script&lang=js"
export * from "./TravelNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./TravelNoteDetail.vue?vue&type=style&index=0&id=0e8df05e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8df05e",
  null
  
)

export default component.exports